"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("antd/dist/antd.css");
var _antd2 = require("antd");
require("./Modal.scss");
var _md = require("react-icons/md");
var _ai = require("react-icons/ai");
var _Button = require("@ccw-pwa-ui/Button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CustomModal = _ref => {
  let {
    variant,
    displayCrossIcon,
    modalHeaderText,
    modalHeaderTextStyle,
    modalDetailText,
    modalDetailText2,
    modalDetailTextStyle,
    displayModal,
    positiveActionButtonTitle,
    negativeButtonActionTitle,
    positiveAction,
    negativeAvtion,
    crossIconAction,
    modalIcon,
    variantBtn1,
    variantBtn2,
    btn1Style,
    btn2Style,
    divStyleBtn1,
    divStyleBtn2,
    wrapperStyle,
    customIcon,
    onClickSupport,
    contactPentair,
    BlueTick,
    selectedCategory,
    modalDetailText3,
    modalDetailText4,
    text4Style,
    imageButton,
    imageButtonAction,
    capture,
    fileSelected,
    checkmark,
    checkmarkStyle,
    camDivStyle,
    camLabelStyle,
    ContinueText,
    hideImageButton,
    modalDetailText2Style,
    showCheckCircle,
    showExclaimationCircle,
    zoomImageSrc,
    imageVariant,
    zoomCarousel,
    selectedImage,
    caption,
    handleImageClick,
    imageListStyle,
    imageModalStyle,
    selectedImageStyle,
    captionContainer,
    captionStyle,
    grid,
    scrollableItem,
    altText,
    selectedAltText,
    imgWidth,
    imgHeight,
    leftArrow,
    rightArrow,
    altLeftArrow,
    altRightArrow,
    children
  } = _ref;
  const sliderRef = (0, _react.useRef)(null);
  const scrollAmount = 100;
  const getIcon = variant => {
    if (!customIcon) {
      switch (variant) {
        case "warning-modal":
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "cust-modal-header-icon"
          }, /*#__PURE__*/_react.default.createElement(_md.MdWarning, {
            className: "cust-warniing-icon"
          }));
        case "password-change-modal":
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "cust-modal-header-icon"
          }, /*#__PURE__*/_react.default.createElement(_ai.AiFillCheckCircle, {
            className: "cust-password-change-icon"
          }));
        case "remove-user-modal":
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "cust-modal-header-icon"
          }, /*#__PURE__*/_react.default.createElement(_md.MdDelete, {
            className: "cust-warniing-icon"
          }));
        case "resend-invitation":
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "cust-modal-header-icon"
          }, /*#__PURE__*/_react.default.createElement(_ai.AiOutlineMail, {
            style: {
              fontSize: 32,
              color: '#0B3471',
              fontWeight: 700,
              lineHeight: "24px",
              margin: "10px",
              width: 49,
              height: 49,
              strokeWidth: 10
            }
          }));
        case "error-modal":
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "cust-modal-header-icon"
          }, /*#__PURE__*/_react.default.createElement(_md.MdWarning, {
            className: "cust-warniing-icon"
          }));
        case "otp-modal":
          break;
        case "info-icon-modal":
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "cust-modal-header-icon"
          }, /*#__PURE__*/_react.default.createElement(_ai.AiFillInfoCircle, {
            className: "cust-info-icon"
          }));
        default:
          break;
      }
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "cust-modal-header-icon"
      }, customIcon);
    }
  };
  const getImageCarousel = imageVariant => {
    switch (imageVariant) {
      case "image-carousel":
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          style: imageModalStyle
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
          src: selectedImage,
          alt: selectedAltText,
          style: selectedImageStyle,
          minWidth: imgWidth,
          minHeight: imgHeight
        })), caption && /*#__PURE__*/_react.default.createElement("div", {
          className: 'caption-container'
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: 'caption-style'
        }, caption)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          className: "box",
          "data-testid": "left-arrow",
          onClick: () => {
            const container = sliderRef.current;
            container.scrollLeft -= scrollAmount;
          }
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: leftArrow,
          className: "imgLeft",
          alt: altLeftArrow
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: 'grid',
          ref: sliderRef
        }, zoomCarousel.map((image, index) => /*#__PURE__*/_react.default.createElement("div", {
          key: index,
          className: scrollableItem,
          "data-testid": "unselected-img",
          onClick: () => handleImageClick(image, index)
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: image,
          alt: altText,
          className: selectedImage === image ? imageListStyle : 'unselected-image'
        })))), /*#__PURE__*/_react.default.createElement("div", {
          className: "box-left",
          "data-testid": "right-arrow",
          onClick: () => {
            const container = sliderRef.current;
            container.scrollLeft += scrollAmount;
          }
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: rightArrow,
          className: "imgRight",
          alt: altRightArrow
        })))));
      default:
        break;
    }
  };
  const getZoomedImage = imageVariant => {
    switch (imageVariant) {
      case "zoom-image":
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex imageZoomDiv"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: zoomImageSrc,
          alt: "",
          className: "imageZoomImgElement"
        })));
      default:
        break;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd2.Modal, {
    centered: true,
    footer: null,
    className: variant,
    style: _objectSpread({
      bottom: 0
    }, wrapperStyle),
    visible: displayModal,
    closable: false,
    okButtonProps: {
      style: {
        display: 'none'
      }
    },
    cancelButtonProps: {
      style: {
        display: 'none'
      }
    }
  }, displayCrossIcon && /*#__PURE__*/_react.default.createElement(_md.MdClose, {
    onClick: crossIconAction,
    className: "cust-cross-icon",
    "data-testid": "cross-Btn"
  }), getIcon(variant), zoomImageSrc ? getZoomedImage(imageVariant) : null, zoomCarousel ? getImageCarousel(imageVariant) : null, contactPentair && contactPentair.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: "1px solid #BFC1C4",
        marginBottom: "13px"
      },
      onClick: () => {
        onClickSupport(item, index + 1);
      },
      id: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontWeight: "".concat(selectedCategory === item ? '700' : '400'),
        fontSize: '16px',
        color: "".concat(selectedCategory === item ? '#006E96' : '#333333')
      }
    }, item), selectedCategory === item && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
      src: BlueTick,
      alt: "right"
    })));
  }), modalHeaderText && /*#__PURE__*/_react.default.createElement("p", {
    className: "cust-modal-title-text",
    style: modalHeaderTextStyle
  }, modalHeaderText), children, modalDetailText && !modalDetailText2 && /*#__PURE__*/_react.default.createElement("p", {
    className: "cust-modal-detail-text",
    style: modalDetailTextStyle
  }, modalDetailText), modalDetailText && modalDetailText2 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-details1-text-style"
  }, showCheckCircle ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ai.AiFillCheckCircle, {
    className: "check-circle-style"
  })) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "cust-modal-detail-text",
    style: modalDetailTextStyle
  }, modalDetailText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-details2-text-style"
  }, showExclaimationCircle ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ai.AiFillExclamationCircle, {
    className: "exclaimation-circle-style"
  })) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "cust-modal-detail-text",
    style: modalDetailText2Style
  }, modalDetailText2))), modalDetailText3 && /*#__PURE__*/_react.default.createElement("div", {
    className: "cust-modal-detail-text",
    style: modalDetailTextStyle
  }, modalDetailText3 === null || modalDetailText3 === void 0 ? void 0 : modalDetailText3.map(item => {
    return /*#__PURE__*/_react.default.createElement("div", null, item);
  })), modalDetailText4 && /*#__PURE__*/_react.default.createElement("div", {
    className: "cust-modal-detail-text",
    style: modalDetailTextStyle
  }, modalDetailText4 === null || modalDetailText4 === void 0 ? void 0 : modalDetailText4.map((item, i) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: text4Style[i],
      onClick: item.onSelect
    }, item.name, item.iconRight && /*#__PURE__*/_react.default.createElement("img", {
      src: checkmark,
      style: checkmarkStyle
    }));
  })), imageButton && /*#__PURE__*/_react.default.createElement("div", {
    style: camDivStyle
  }, /*#__PURE__*/_react.default.createElement("label", {
    style: camLabelStyle
  }, ContinueText, fileSelected && /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    name: "images",
    multiple: true,
    onChange: imageButtonAction,
    variant: "primary-long",
    capture: capture,
    accept: "image/*, .heic",
    style: hideImageButton
  }))), positiveActionButtonTitle && /*#__PURE__*/_react.default.createElement("div", {
    style: divStyleBtn1
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: positiveAction,
    variant: variantBtn1 ? variantBtn1 : "primary-long",
    title: positiveActionButtonTitle,
    buttonStyle: btn1Style ? _objectSpread({}, btn1Style) : {}
  })), negativeButtonActionTitle && /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({
      marginTop: 15
    }, divStyleBtn2)
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: negativeAvtion,
    variant: variantBtn2 ? variantBtn2 : "outline-primary-long",
    title: negativeButtonActionTitle,
    buttonStyle: btn2Style ? _objectSpread({}, btn2Style) : {}
  }))));
};
var _default = exports.default = CustomModal;